require("prismjs/themes/prism-okaidia.css");
require('./src/utils/firebaseConfig');
require('./src/utils/fontawesome');